export interface NotificareDynamicLink {
  readonly target: string;
}
